import type { GraphRootReference } from "@mind/contracts/browser";
import type { GraphTraversalInput } from "./graphApi.js";

export const graphQueryKeys = {
  all: ["graph"] as const,
  workspaces: () => ["graph", "workspaces"] as const,
  roots: (workspaceId: string, query: string) => ["graph", "roots", workspaceId, query] as const,
  traversal: (input: GraphTraversalInput) =>
    [
      "graph",
      "traversal",
      input.workspaceId,
      input.root,
      input.projectId ?? null,
      input.accountId ?? null,
      input.tag ?? null,
      input.includeArchived,
      input.cursor ?? null,
      input.limit ?? 50,
    ] as const,
};

export function graphRootKey(root: GraphRootReference): string {
  return `${root.type}:${root.id}:${root.revision}`;
}
